export default __webpack_public_path__ + "static/media/xdef-esrb-rating-extended.4e96259a.png";